import { formatPrice } from '../ProductDetailPage/helpers';

const getProductPrices = (productData) => {
  const productPrices = {};
  if (
    productData.reference_price_range &&
    productData.reference_price_range.type === 'COMPAREATPRICE'
  ) {
    productPrices.sale = true;
  }
  const msrp = productData.msrp_range;
  const price = productData.price_range;
  const minEqual = msrp.min_price === price.min_price;
  const maxEqual = msrp.max_price === price.max_price;
  productPrices.msrpNoRange = msrp.min_price === msrp.max_price;
  productPrices.priceNoRange = price.min_price === price.max_price;
  if (!minEqual || !maxEqual) {
    const minMsrpPrice = formatPrice(msrp.min_price);
    const maxMsrpPrice = formatPrice(msrp.max_price);
    productPrices.msrp = productPrices.msrpNoRange
      ? `${minMsrpPrice}`
      : `${minMsrpPrice} - ${maxMsrpPrice}`;
  }
  const minPrice = formatPrice(price.min_price);
  const maxPrice = formatPrice(price.max_price);
  productPrices.zolaPrice = productPrices.priceNoRange
    ? `${minPrice}`
    : `${minPrice} - ${maxPrice}`;
  return productPrices;
};

export default getProductPrices;
